import clsx from "clsx";
import { useTranslation } from "hooks/use-translation";
import { useCallback, useEffect, useState } from "react";

/* eslint-disable quotes */
// These are what Cognito considers to be special characters
const specialCharacters = [
  "^",
  "$",
  "*",
  ".",
  "[",
  "]",
  "{",
  "}",
  "(",
  ")",
  "?",
  "-",
  '"',
  "!",
  "@",
  "#",
  "%",
  "&",
  "/",
  "\\",
  ",",
  ">",
  "<",
  "'",
  ":",
  ";",
  "|",
  "_",
  "~",
  "`",
  "+",
  "=",
];
/* eslint-enable */

export function usePasswordCriteria() {
  const { tcomponent } = useTranslation({ component: "password-criteria" });

  const [password, setPassword] = useState("");
  const [validation, setValidation] = useState({
    hasCapitalLetter: false,
    hasNumber: false,
    hasSymbol: false,
    hasLength: false,
  });
  const [isValid, setIsValid] = useState(false);

  const validate = useCallback(
    (password) => {
      const result = {
        hasLowerCaseLetter: /[a-z]/.test(password),
        hasCapitalLetter: /[A-Z]/.test(password),
        hasNumber: /[0-9]/.test(password),
        hasSymbol: specialCharacters.some((char) => password.includes(char)),
        hasLength: /^.{8,}$/.test(password),
      };

      setValidation(result);
      setIsValid(
        result.hasLowerCaseLetter &&
          result.hasCapitalLetter &&
          result.hasLength &&
          result.hasNumber &&
          result.hasSymbol,
      );
    },
    [setValidation],
  );

  const validationClass = useCallback(
    (bool) => (bool ? "text-teal-500 font-semibold" : "text-red-500"),
    [validation],
  );

  useEffect(() => {
    validate(password);
  }, [password]);

  const render = useCallback(() => {
    return (
      <div>
        <p className="text-xs">
          <span>{tcomponent("must-have")}</span>{" "}
          <span
            className={clsx(validationClass(validation.hasLowerCaseLetter))}
          >
            {tcomponent("lowercase-letter")}
          </span>
          {tcomponent("a")}
          <span className={clsx(validationClass(validation.hasCapitalLetter))}>
            {tcomponent("capital-letter")}
          </span>
          {tcomponent("a")}
          <span className={clsx(validationClass(validation.hasNumber))}>
            {tcomponent("number")}
          </span>
          {tcomponent("and-a")}
          <span className={clsx(validationClass(validation.hasSymbol))}>
            {tcomponent("symbol")}
          </span>
          {". "}
          <span>{tcomponent("must-also-be-at-least")}</span>{" "}
          <span className={clsx(validationClass(validation.hasLength))}>
            {tcomponent("eight-characters")}
          </span>
          {"."}
        </p>
      </div>
    );
  }, [validation]);

  return [render, isValid, setPassword];
}
